/**
 * @generated SignedSource<<77901a4d26c14ce3e165e61f1fbc7d81>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f

import type { ConcreteRequest } from 'relay-runtime';
export type useFeatureDiscoveryFeatureDiscoveryQuery$variables = Record<PropertyKey, never>;
export type useFeatureDiscoveryFeatureDiscoveryQuery$data = {
  readonly featureDiscovery: ReadonlyArray<{
    readonly featureKey: string | null;
    readonly pluginKey: string | null;
  } | null> | null;
};
export type useFeatureDiscoveryFeatureDiscoveryQuery = {
  response: useFeatureDiscoveryFeatureDiscoveryQuery$data;
  variables: useFeatureDiscoveryFeatureDiscoveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "DiscoveredFeature",
    "kind": "LinkedField",
    "name": "featureDiscovery",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "pluginKey"
      },
      {
        "kind": "ScalarField",
        "name": "featureKey"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
    "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
    "metadata": {},
    "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
    "operationKind": "query",
    "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
  }
};
})();

(node as any).hash = "8577be880df828fbee71c90a7701eddf";

export default node;
